import { SellingMode, type Product, type ScheduleTime } from '@src/core/buyerApiClient';
import { extractLimitFrom, tariffDepedencyStatus } from '@src/domains/tariffs';
import type { TariffsPerType, TariffsState } from '@src/stores/product';
import { isDependentTariffAndIsSelected, isNotPossibleToSelect } from './tariffSelection';

export function shouldShowIndependentTariffNotSelectedError(
  typeId: string,
  listOfTariffsPerType: TariffsPerType[],
  selectedHour: ScheduleTime | undefined,
): boolean {
  const { areSomeIndependentTariffSelected } = tariffDepedencyStatus(listOfTariffsPerType, selectedHour);
  if (areSomeIndependentTariffSelected) return false;
  return isDependentTariffAndIsSelected(typeId, listOfTariffsPerType, selectedHour);
}

export function shouldShowSingleQuantityError(
  typeId: string,
  product: Pick<Product, 'sellingMode'>,
  listOfTariffsPerType: TariffsPerType[],
  isTotalQtyExceedingLimit: boolean,
): boolean {
  return (
    product.sellingMode === SellingMode.WithDateOnly &&
    isNotPossibleToSelect(typeId, listOfTariffsPerType) &&
    !isTotalQtyExceedingLimit
  );
}

export function shouldShowMultipleQuantityError(
  product: Pick<Product, 'sellingMode'>,
  isTotalQtyExceedingLimit: boolean,
): boolean {
  return product.sellingMode === SellingMode.WithDateOnly && isTotalQtyExceedingLimit;
}

export function shouldShowMaxAvailabilityReachedError(
  tariff: TariffsPerType,
  product: Pick<Product, 'sellingMode' | 'maxSaleTariffQuantity'>,
  tariffsInformation: TariffsState,
  selectedHour: ScheduleTime | undefined,
): boolean {
  if (product.sellingMode !== SellingMode.WithDateAndTime) return false;
  if (selectedHour != null) return false;
  if (tariff.selectedQuantity <= 0) return false;

  const range = extractLimitFrom(tariffsInformation, tariff, undefined);
  if (!range) return false;

  const occupationMax = range[1];
  if (occupationMax <= 0 || occupationMax > product.maxSaleTariffQuantity) return false;

  return tariff.selectedQuantity === occupationMax;
}
